var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "folder"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector ",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 1.875C1.83424 1.875 1.67527 1.94085 1.55806 2.05806C1.44085 2.17527 1.375 2.33424 1.375 2.5V9.5C1.375 9.66576 1.44085 9.82473 1.55806 9.94194C1.67527 10.0592 1.83424 10.125 2 10.125H10C10.1658 10.125 10.3247 10.0592 10.4419 9.94194C10.5592 9.82473 10.625 9.66576 10.625 9.5V4C10.625 3.83424 10.5592 3.67527 10.4419 3.55806C10.3247 3.44085 10.1658 3.375 10 3.375H5.5C5.37462 3.375 5.25753 3.31234 5.18798 3.20801L4.29931 1.875H2ZM1.02773 1.52773C1.28559 1.26987 1.63533 1.125 2 1.125H4.5C4.62538 1.125 4.74247 1.18766 4.81202 1.29199L5.70069 2.625H10C10.3647 2.625 10.7144 2.76987 10.9723 3.02773C11.2301 3.28559 11.375 3.63533 11.375 4V9.5C11.375 9.86467 11.2301 10.2144 10.9723 10.4723C10.7144 10.7301 10.3647 10.875 10 10.875H2C1.63533 10.875 1.28559 10.7301 1.02773 10.4723C0.769866 10.2144 0.625 9.86467 0.625 9.5V2.5C0.625 2.13533 0.769866 1.78559 1.02773 1.52773Z",
  fill: "#00538F"
}));

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.5ad59b2b.svg";
export { ForwardRef as ReactComponent };